<ng-container *ngIf="(products$ | async) as products; else loader">
  <ng-container *ngIf="areProductsOfCurrentGroupLoaded$ | async; else loader">
    <ng-container
      *ngIf="selectedProducts$ | async as selectedProducts; else loader"
    >
      <prlw-product-filter-ui
        [products]="products"
        [selectedProducts]="selectedProducts"
        (toggleAllProductsOfCurrentGroup)="toggleAllProductsOfCurrentGroup()"
        (toggleProduct)="toggleProduct($event)"
        (initResizeObserver)="initResizeObserver($event)"
        (setScrollHorizontalPosition)="setScrollHorizontalPosition($event)"
        [isOverflowRight]="isOverflowRight$ | async"
        [isOverflowLeft]="isOverflowLeft$ | async"
      ></prlw-product-filter-ui>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loader>
  <prlw-product-loader-ui></prlw-product-loader-ui>
</ng-template>
